import React from "react";
import { createRoot } from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import About from "./components/about";
import Home from "./components/home";
import Contact from "./components/contact";
import Products from "./components/products";
import NewProducts from "./components/newarrivals";
import Brochures from "./components/brochures";
import Auth from "./components/auth";
import Operations from "./components/operations";
import FileUploadComponent from "./components/imageuploader"
import InvoiceForm from "./components/invoiceform"
import DeliveryChallan from "./components/deliverychallan"
import InvoiceReports from "./components/invoicereports"
import ImageDeletion from './components/imageDeletion';
import Product from "./components/product";
import Dashboard from "./components/dashboard";

import { BrowserRouter, Route, Routes } from "react-router-dom";

const root = createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/auth" element={<Auth />} />
      <Route path="/brochures" element={<Brochures />} />
      <Route path="/products" element={<Products />} />
      <Route path="/newproducts" element={<NewProducts />} />
      <Route path="/operations" element={<Operations />} />
      <Route path="/uploadimage" element={<FileUploadComponent />} />
      <Route path="/invoicereports" element={<InvoiceReports />} />
      <Route path="/imageDeletion" element={<ImageDeletion />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/taxinvoice" element={<InvoiceForm type="tax" desc="Tax Invoice" />} />
      <Route path="/performainvoice" element={<InvoiceForm type="pro" desc="Pro forma invoice / Quotation" />} />
      <Route path="/creditnote" element={<InvoiceForm type="credit" desc="Credit Note" />} />
      <Route path="/deliverychallan" element={<DeliveryChallan type="deliverychallan" desc="Delivery Challan" />} />
      <Route path="/wallpapers" element={<Product product="wallpapers" desc="Wallpapers" />} />
      <Route path="/agrass" element={<Product product="agrass" desc="Artificial Grass" />} />
      <Route path="/blinds" element={<Product product="blinds" desc="Blinds" />} />
      <Route path="/ceilings" element={<Product product="ceilings" desc="Ceilings" />} />
      <Route path="/wpcbaffleceilings" element={<Product product="wpcbaffleceilings" desc="Wpc Baffle Ceilings" />} />
      <Route path="/soffitpanels" element={<Product product="soffitpanels" desc="Soffit Panels" />} />
      <Route path="/claddings" element={<Product product="claddings" desc="Claddings" />} />
      <Route path="/doormats" element={<Product product="doormats" desc="Door Mats" />} />
      <Route path="/modulercarpets" element={<Product product="carpettiles" desc="Modular Carpet Tiles" />} />
      <Route path="/awnings" element={<Product product="awnings" desc="Awnings" />} />
      <Route path="/pvcpanels" element={<Product product="pvc" desc="PVC Panels" />} />
      <Route path="/foampanels" element={<Product product="foampanels" desc="Foam Panels" />} />
      <Route path="/verticalgarden" element={<Product product="verticalgarden" desc="Vertical Gardens Exterior & Interior" />} />
      <Route path="/nexacarpets" element={<Product product="nexa" desc="Nexa" />} />
      <Route path="/wall2wall" element={<Product product="wall2wallc" desc="Wall 2 Wall Carpets" />} />
      <Route path="/woodenfloorings" element={<Product product="woodenfloorings" desc="Wooden Floorings" />} />
      <Route path="/gymfloorings" element={<Product product="gym" desc="Gym Floorings" />} />
      <Route path="/solar" element={<Product product="solar" desc="Solar Films" />} />
      <Route path="/fundermax" element={<Product product="fundermax" desc="Fundermax" />} />
      <Route path="/aluminiumlouverpanels" element={<Product product="aluminiumlouverpanels" desc="Alumininum Louver Panels" />} />
      <Route path="/indoorwpclouvers" element={<Product product="indoorwpclouvers" desc="Indoor WPC Louvers" />} />
      <Route path="/outdoorwpclouvers" element={<Product product="outdoorwpclouvers" desc="Outdoor WPC Louvers" />} />
      <Route path="/hpl" element={<Product product="hpl" desc="HPL" />} />
      <Route path="/acousticbaffleceilings" element={<Product product="acousticbaffleceilings" desc="Acoustic Baffle Ceilings" />} />
    </Routes>
  </BrowserRouter>
);
